"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Button_1 = require("@Components/Buttons/Button");
const publisher_form_type_1 = require("@App/enum/publisher-form-type");
const contexts_1 = require("@App/contexts");
const PublisherSearchResultsTable_1 = __importDefault(require("@Components/WorkRegistrationSubs/PublisherFormSteps/PublisherSearchResultsTable"));
const PublisherAfterFindForm = (props) => {
    const { publisherSearchStore, publisherStepStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const { itemWasAdded, setFinedPublisherToDraft, addPublisherToDraft, topLevelClass } = props;
    const searchResult = publisherSearchStore.publisherSearchModel;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: topLevelClass },
            react_1.default.createElement("h2", null, searchResult && searchResult.results.length > 1
                ? 'We already have publishers with those details:'
                : 'We already have a publisher with those details:'),
            searchResult && searchResult.results.length > 0 ? (react_1.default.createElement(PublisherSearchResultsTable_1.default, { itemWasAdded: itemWasAdded, setFoundPublisherToDraft: setFinedPublisherToDraft })) : null,
            react_1.default.createElement("p", { className: 'cant-find-title-after-find' }, "Not the correct publisher?"),
            react_1.default.createElement("div", { className: "buttons-area" },
                react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'primary', onClick: () => publisherStepStore.setFormType(publisher_form_type_1.PublisherFormType.create) }, "Back to create"),
                react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'primary', onClick: addPublisherToDraft }, "Confirm & create new")))));
};
exports.default = PublisherAfterFindForm;
